import RouteMap from './container'

export default RouteMap
